import React from 'react';
import { styled } from '@mui/system';
import colors from '../../../../theme/emotion/colors';

const StyledButtonSection = styled('div')({
  position: 'fixed',
  bottom: '2rem',
  left: 0,
  right: 0,
  padding: '1.25rem',
  backgroundColor: colors.neutral.grey,
  zIndex: 10,
  '@supports (padding-bottom: env(safe-area-inset-bottom))': {
    paddingBottom: 'calc(1.25rem + env(safe-area-inset-bottom))',
  },
});

interface OnboardingButtonSectionProps {
  children: React.ReactNode;
}

const OnboardingButtonSection: React.FC<OnboardingButtonSectionProps> = ({ children }) => {
  return <StyledButtonSection>{children}</StyledButtonSection>;
};

export default OnboardingButtonSection; 